import React from 'react'
import { Login } from '../components/auth/Login'
import {BaseComponent} from '../components/base/BaseComponent'

export const LoginScreen: React.FC = () => {
    return (
        <BaseComponent title="Login" component={Login} />
    )
}
